<!--
 Open MCT, Copyright (c) 2014-2023, United States Government
 as represented by the Administrator of the National Aeronautics and Space
 Administration. All rights reserved.

 Open MCT is licensed under the Apache License, Version 2.0 (the
 "License"); you may not use this file except in compliance with the License.
 You may obtain a copy of the License at
 http://www.apache.org/licenses/LICENSE-2.0.

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 License for the specific language governing permissions and limitations
 under the License.

 Open MCT includes source code licensed under additional open source
 licenses. See the Open Source Licenses file (LICENSES.md) included with
 this source code distribution or the Licensing information page available
 at runtime from the About dialog for additional information.
-->
<template>
  <tr class="c-telemetry-table__sizing-tr">
    <td>SIZING ROW</td>
  </tr>
</template>

<script>
export default {
  props: {
    isEditing: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change-height'],
  watch: {
    isEditing: function (isEditing) {
      if (isEditing) {
        this.pollForRowHeight();
      } else {
        this.clearPoll();
      }
    }
  },
  mounted() {
    this.$nextTick().then(() => {
      this.height = this.$el.offsetHeight;
      this.$emit('change-height', this.height);
    });
    if (this.isEditing) {
      this.pollForRowHeight();
    }
  },
  unmounted() {
    this.clearPoll();
  },
  methods: {
    pollForRowHeight() {
      this.clearPoll();
      this.pollID = window.setInterval(this.heightPoll, 300);
    },
    clearPoll() {
      if (this.pollID) {
        window.clearInterval(this.pollID);
        this.pollID = undefined;
      }
    },
    heightPoll() {
      let height = this.$el.offsetHeight;
      if (height !== this.height) {
        this.$emit('change-height', height);
        this.height = height;
      }
    }
  }
};
</script>
